import { roundNumber } from '@/utils/maths';
import clsx from 'clsx';
import { useNumberAnimation } from '../hooks/useNumberAnimation';
import styles from '../style.module.css';
import SvgFilter from './SvgFilter';

const Total = ({
  total,
  unit,
  animate = true,
}: {
  total: number;
  unit: string;
  animate?: boolean;
}) => {
  const { value } = useNumberAnimation(total, animate);
  return (
    <>
      <div>
        <b>{'Total: '}</b>
        <span className={clsx({ [styles.animate]: false })}>
          {roundNumber(value)}
        </span>
        {` ${unit}`}
      </div>
      <SvgFilter />
    </>
  );
};

export default Total;
